import { render } from "./RatingTableHeader.vue?vue&type=template&id=47845926&scoped=true"
import script from "./RatingTableHeader.vue?vue&type=script&lang=js"
export * from "./RatingTableHeader.vue?vue&type=script&lang=js"

import "./RatingTableHeader.vue?vue&type=style&index=0&id=47845926&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47845926"]])

export default __exports__